module.exports = __webpack_public_path__ + "img/logo.fda7005e.png";